<template>
  <div class="check-contenido">
    <div class="conjunto-titular">
      <p class="check-titular">{{titulo}} 
      </p>
      
    </div>
    <div class="check-contenedor-checkbox">
      <div class="checkbox" v-for="(corte,i) in cortes_distancia_genetica" :key="i">
        <svg width=40 height=5>
            <line
                x1=0
                x2=50
                y1=3
                y2=3
                :stroke="corte.stroke_color"
                :stroke-dasharray="corte.dash_array"
            />
        </svg>
        <span>
            {{corte.texto}}
        </span>
          
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NomenclaturaDistanciaGenetica',
  components: {
  },
  props: {
    titulo: String,
    cortes_distancia_genetica: Array
  },
}
</script>
<style scoped lang="scss">
$padding: $gap * .5;

.check-contenido {
  flex: 1 0;
  padding: $padding*.5 $padding;
  @media (max-width: map-get($media-queries-limit, "mobile")) {
    border-radius: 10px;
    box-shadow: 0px 5px 5px -1px #dddddd;
    margin-bottom: $padding*.5;
  }
}
.conjunto-titular {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .boton-quitar-todos {
    background-color: var(--control-bg-color);
    border: 1px solid var(--control-color);
    color: var(--control-color);
  }
}
.check-descripcion {
  display: none;
  //@media (min-width: map-get($media-queries-limit, "mobile")) {
    display: block;
    font-size: 16px;
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      font-size: 14px;
    }
    line-height: 1.1em;
    margin: $padding*.25 0 $padding*.5;
  //}
}
div.check-contenedor-checkbox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
div.checkbox {
  margin: 0 0 10px 0;
  flex: 0 0 50%;
  input {
    display: block;
    margin-right: 2px;
  }
  .color {
    border-radius: 50%;
    width: 25px;
    min-width: 25px;
    height: 25px;
    display: inline-block;
  }
  .nombre {
    font-size: 16px;
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      font-size: 14px;
    }
    line-height: 1.1em;
    max-width: 100px;
  }
  .span-info{
    margin:0;
  }
}
</style>
